import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Capabilities from "./components/Capabilities";
import Experience from "./components/Experience";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
    return (
        <ThemeProvider>
            <div className="grain min-h-screen bg-base text-fg">
                <Navbar />
                <main>
                    <Header />
                    <Capabilities />
                    <Experience />
                    <Portfolio />
                    <Contact />
                </main>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default App;